import { useState, useCallback } from 'react';
import { pwh201Api } from '../../../services/pwh201Api';
import type { FH110 } from '../../../services/pwh201Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for a master record */
  const resolveAllNames = useCallback(async (data: Partial<FH110>) => {
    const entries: [string, string, string][] = [
      ['payee', 'supplier', data.fh110_15 || ''],
      ['company', 'supplier', data.fh110_16 || ''],
      ['department', 'department', data.fh110_37 || ''],
      ['currency', 'currency', data.fh110_25 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        pwh201Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await pwh201Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, setNames, resolveAllNames, resolveSingleName, clearNames };
}
